import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Data, NavigationEnd, Router, RouterModule} from '@angular/router';
import {filter, map, mergeMap} from 'rxjs/operators';
import {TablerIconsModule} from 'angular-tabler-icons';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {CommonModule } from '@angular/common';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TablerIconsModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: [],
})
export class AppBreadcrumbComponent {
  // @Input() layout;
  pageInfo: Data | any = Object.create(null);
  public otherTitle: string = '';
  myurl: any = this.router.url.slice(1).split('/');
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translate: TranslateService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      .subscribe((event) => {
        const titleKey = event['title'] || '';
        const translated = titleKey ? this.translate.instant(titleKey) : '';
        this.titleService.setTitle(`Portal - ${translated || titleKey}`);
        this.pageInfo = event;
        // set optional otherTitle from route data (if provided)
        this.otherTitle = event['otherTitle'] || '';
      });
  }
}
